export class JQElementHelper {
    iterateSelector($parent, func) {
        for (let elem of $parent) {
            func($(elem));
        }
    }
}
